import CardSkeleton from "@/components/skeletons/CardSkeleton";

export default function TaxPlannerSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
      <div className="lg:col-span-7 space-y-5">
        <CardSkeleton lines={3} />
        <CardSkeleton lines={5} />
        <CardSkeleton lines={4} />
      </div>
      <div className="order-first lg:order-none lg:col-span-5">
        <CardSkeleton lines={6} />
      </div>
    </div>
  );
}
